export function showBootstrapError(error: unknown): void {
  console.error(error);

  let errorUi = document.getElementById('blazor-error-ui');
  if (!errorUi) {
    errorUi = createErrorUi(error);
    document.body.appendChild(errorUi);
  }

  errorUi.style.display = 'block';
}

function createErrorUi(error: unknown): HTMLDivElement {
  const errorUi = document.createElement('div');
  errorUi.id = 'blazor-error-ui';
  errorUi.innerHTML = `
        <div class="d-flex gap-3">
            <div class="d-flex flex-column gap-1 overflow-hidden">
                <div class="d-flex flex-column flex-lg-row gap-2 align-items-lg-center justify-content-lg-between">
                    <div id="blazor-error-ui-unhandled-error-info">An unhandled error has occurred.</div>

                    <button type="button" class="d-inline-flex gap-2 align-items-center justify-content-center btn btn-primary" data-action="reload">
                        <i class="fas fa-rotate"></i><span id="blazor-error-ui-unhandled-error-refresh">Try reload</span>
                    </button>

                    <button id="blazor-error-ui-unhandled-error-copy"
                            type="button"
                            class="d-inline-flex gap-2 align-items-center justify-content-center btn btn-primary"
                            data-bs-title="Copied to clipboard">
                        <i class="fas fa-copy"></i><span>Copy error to report</span>
                    </button>
                </div>
                <pre class="console-error bg-dark bg-opacity-25 p-2 rounded-1 collapse" style="font-size: .75em"></pre>
            </div>
            <div class="pt-2">
                <a id="blazor-error-ui-dismiss" class="dismiss"><i class="fas fa-xmark"></i></a>
            </div>
        </div>`;

  const errorText = error instanceof Error ? (error.stack ?? error.message) : String(error);
  const consoleError = errorUi.querySelector('pre.console-error');
  if (consoleError) {
    consoleError.textContent = errorText;
  }

  errorUi.querySelector('[data-action="reload"]')?.addEventListener('click', () => {
    window.location.reload();
  });

  errorUi.querySelector('#blazor-error-ui-unhandled-error-copy')?.addEventListener('click', () => {
    void navigator.clipboard.writeText(errorText);
  });

  errorUi.querySelector('#blazor-error-ui-dismiss')?.addEventListener('click', () => {
    errorUi.style.display = 'none';
  });

  return errorUi;
}
